/**
 * What a Test Connection leg's remedy link does (Azure Storage, plan §3.2): "Add share names" on the File leg of an
 * Entra connection that cannot list shares moves the focus to the named-shares form field.
 */
import type { TrackFunction } from '@/core/analytics/analyticsTypes';
import { ADD_SHARE_NAMES } from '../utils/storageTestLegs';
import { revealControl } from '../connection-dialog/pane/formSectionReveal';

export const NAMED_SHARES_INPUT_TEST_ID = 'storage-named-shares-input';

export function focusLegRemedy(actionId: string, track?: TrackFunction): void {
  if (actionId !== ADD_SHARE_NAMES.id) return;
  track?.('ui:storage_test_add_share_names');
  const field = document.querySelector<HTMLElement>(`[data-testid="${NAMED_SHARES_INPUT_TEST_ID}"]`);
  revealControl(field, () => {
    field?.scrollIntoView?.({ block: 'center' });
    field?.focus();
  });
}
